import PromoCarousel from './PromoCarousel.module';

export default PromoCarousel;
